import React, { FC, useState, useContext } from "react";
import { useModal } from "../../../customHooks/useModal";
import Button from "../../../components/UI/button/GgButton";
import Modal from "../../../components/modal/Modal";
import CalcDetails from "./CalcDetails/CalcDetails";
import { dateFormat, formatCalcName } from "../../../utils";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { IUsers } from "../../../models/IUsers";
import { Context } from "../../..";
import Spinner from "../../../components/UI/spinner/Spinner";
import { ICalcs } from "../../../models/IUserCalc/ICalcs";
import { useParams } from "react-router-dom";
import { showSuccessToast } from "../../../components/toasts";

interface ICalcItem {
  data: any;
  user?: IUsers;
  pathObject?: string;
  setCalcItem: (data: any) => void;
  actionData?: any;
}

const CalcItem: FC<ICalcItem> = ({ data, user, pathObject, setCalcItem, actionData }) => {
  const modal = useModal();
  const [loading, setLoading] = useState<boolean>(false);
  const { users } = useContext(Context)

  const handleDownload = async () => {
    const targetDiv = document.getElementById("calc-details");
    if (targetDiv) {
      const canvas = await html2canvas(targetDiv);
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 10;

      // Calculate the position for the text
      const textX = margin;
      const textY = margin + 10; // Add some vertical spacing before the image

      // Add additional text to the PDF
      pdf.setFontSize(12);
      pdf.text(formatCalcName(data.name.split(" ")[0]), textX, textY);
      pdf.text(user?.name || "", pageWidth - margin, textY, {
        align: "right",
      });
      pdf.setFontSize(10);
      pdf.text(user?.email || "", pageWidth - margin, textY + 5, {
        align: "right",
      });
      pdf.text(dateFormat(data.created_at), pageWidth - margin, textY + 10, {
        align: "right",
      });

      // Calculate the dimensions of the image
      const imageWidth = pageWidth - 2 * margin;
      let imageHeight = (canvas.height * imageWidth) / canvas.width;
      let heightLeft = imageHeight;

      // Calculate the position for the image
      const imageX = margin;
      const imageY = textY + 10; // Add some vertical spacing after the text
      let position = imageY;

      // Add the captured image to the PDF
      pdf.addImage(imgData, "PNG", imageX, imageY, imageWidth, imageHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imageHeight;
        pdf.addPage();
        pdf.addImage(
          imgData,
          "PNG",
          imageX,
          position + 30,
          imageWidth,
          imageHeight
        );
        heightLeft -= pageHeight;
      }

      pdf.save(`${user?.name}.pdf`);
    }
  };

  const deleteCalcData = async () => {
    const userId = users.selectedUser._id
    const calcType = pathObject
    const replacedText = calcType?.slice(0, -2);
    if (window.confirm(`Are you sure you want to delete #${replacedText} document? `)) {
      if (userId && calcType) {
        setLoading(true);
        const userId = users.selectedUser._id
        const body = {
          id: userId,
          pathObject: calcType,
        }
        await users.calcDeleteData(body);
        await loadNewUser()
        setLoading(false);
        showSuccessToast("Document Delete Successfully")
      }
    }
  }

  const { calc } = useParams();

  async function loadNewUser() {
    const response = await users.loadOne(users.selectedUser._id);
    if (response) {
      users.setSelectedUser(response);
      const calcProp: keyof ICalcs = calc as keyof ICalcs;
      const calcs: any = response?.calc;
      setCalcItem(calcs[calcProp]);
    }
  }

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div className="calc-item">
          <div className="calc-info">
            <div className="calc-title">
              {formatCalcName(data.name.split(" ")[0])}
            </div>
            <div className="calc-content">
              Created: {dateFormat(data.created_at)}
            </div>
          </div>
          <div className="controls">
            <Button
              label="View details"
              stylesType="border"
              onPress={modal.openModal}
            />
            {actionData?.delete ? (
              <Button
                label="Delete"
                onPress={() => deleteCalcData()}
              />
            ) : ""}
          </div>
        </div>
      )}
      <Modal
        show={modal.showModal}
        onClose={modal.setModalShow}
        title={formatCalcName(data.name.split(" ")[0])}
        onSubmit={handleDownload}
        showSubmit={true}
        submitLabel="Download"
      >
        <CalcDetails result={data.result} inputData={data.inputData} />
      </Modal>
    </>

  )
};

export default CalcItem;
